import React from 'react'

function Content() {
  return (
    // <div className='mt-10 flex flex-col items-center h-full'>
      <section className="pt-16 flex items-center justify-center pb-24 px-10 overflow-hidden relative">
        <div>
        <p className="text-xl text-center md:text-6xl font-extrabold text-body-color leading-relaxed text-transparent bg-clip-text bg-gradient-to-tl from-green-400 via-sky-500 to-blue-500 uppercase mb-3 md:mb-16">
          BIRD META Utilities
         </p>
          
          <div className='mt-8'>
            
            <div className=' w-full grid gap-6 grid-cols-1 md:grid-cols-2'>
              <div className='relative flex flex-col overflow-hidden rounded-md px-5 bg-white bg-gradient-to-r bg-gree from-blue2 via-blue-300 to-green-200'>
                <div className='flex flex-col items-start'>
                  <img src='images/1.png' alt='' className='w-12 py-3'/>
                  <h2 className='pb-4 font-extrabold'>BIRD PERK</h2>
                  <p className='pb-4 text-lg'>Early OG and WL spots, exclusive discord invites for holders, discount on tools</p>
                </div>
              </div>

              <div className='relative flex flex-col overflow-hidden rounded-md px-5 bg-white bg-gradient-to-r from-green-200 via-green1 to-blue2'>
                <div className='flex flex-col items-start'>
                  <img src='images/2.png' alt='' className='w-12 py-3'/>
                  <h2 className='pb-4 font-extrabold'>BIRDEX PACK</h2>
                  <p className='pb-4 text-lg'>Unreleased Alpha calls, quick flips to make a return of 5X to 10X in a short period</p>
                </div>
              </div>

              <div className='relative flex flex-col overflow-hidden rounded-md px-5 bg-white bg-gradient-to-r from-blue4 via-blue6 to-blue7'>
                <div className='flex flex-col items-start'>
                  <img src='images/3.png' alt='' className='w-12 py-3'/>
                  <h2 className='pb-4 font-extrabold'>BIRD TRADE</h2>
                  <p className='pb-4 text-lg'>Building an innovative automatic NFTs trading system led by the community</p>
                </div>
              </div>

              <div className='relative flex flex-col overflow-hidden rounded-md px-5 bg-white bg-gradient-to-r from-blue7 via-blue9 to-blue-700'>
                <div className='flex flex-col items-start'>
                  <img src='images/4.png' alt='' className='w-12 py-3'/>
                  <h2 className='pb-4 font-extrabold'>BETA ACCESS</h2>
                  <p className='pb-4 text-lg'>Unlimited access to private chats, Signals alerts when a project is about to pump.</p>
                </div>
              </div>

              <div className='relative flex flex-col overflow-hidden rounded-md px-5 bg-white bg-gradient-to-r to-blue11 via-blue10 from-blue-700 '>
                <div className='flex flex-col items-start'>
                  <img src='images/5.png' alt='' className='w-12 py-3'/>
                  <h2 className='pb-4 font-extrabold'>MARKETPLACE</h2>
                  <p className='pb-4 text-lg'>Partnership and in Collaboration with projects for purchasing WL with gained tokens</p>
                </div>
              </div>

              <div className='relative flex flex-col overflow-hidden rounded-md px-5 bg-white bg-gradient-to-r bg-radial-at-r to-blue-700 via-blue10 from-blue11'>
                <div className='flex flex-col items-start'>
                  <img src='images/1.png' alt='' className='w-12 py-3'/>
                  <h2 className='pb-4 font-extrabold'>BIRD TOKENS </h2>
                  <p className='pb-4 text-lg'>Customised tradable Bird Token, that will be used in the Marketplace </p>
                </div>
              </div>

            </div> 
          </div>
        </div>
      </section>
    //</div>
  )
}

export default Content